import { render, staticRenderFns } from "./custom-field-widget.vue?vue&type=template&id=c14c974e&"
import script from "./custom-field-widget.vue?vue&type=script&lang=js&"
export * from "./custom-field-widget.vue?vue&type=script&lang=js&"
import style0 from "./custom-field-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports